import mediaNewsFirst from "../../assets/media-news-first.png";
import mediaNewsAhmdabad from "../../assets/media-news-ahmdabad.png";
import mediaNewsStartUp from "../../assets/media-news-startup.png";
import mediaNewsNepal from "../../assets/media-news-nepal.png";

// Sample media data
export const mediaData = [
  {
    id: 1,
    title: "FIRST INDIA",
    image: mediaNewsFirst.src,
    description:
      "New Delhi: Squeezing salon appointments into a busy day’s schedule is now going to be a hassle-free task. SalonTym, a user-friendly app launched in August 2022, is revolutionising the way Indians experience beauty services. Founded by Geeta Chetri and Vishal Saini, SalonTym allows users to book professional hairstylists, beauticians, and other specialists for waxing, manicures, and pedicures in the comfort and convenience of their own homes.",
    link: "https://firstindia.co.in/news/press-releases/beauty-on-demand-salontym-app-delivers-salon-level-care-at-home",
  },
  {
    id: 2,
    title: "AHMEDABAD MIRROR",
    image: mediaNewsAhmdabad.src,
    description:
      "SalonTym understands that quality matters. The platform partners only with skilled and experienced professionals who meet their high standards. These professionals are equipped with modern tools and techniques, ensuring a top-notch experience for the users in the comfort of their homes. SalonTym fosters a community passionate about beauty and innovation. The app provides users access to current trends and educational resources, keeping them informed and inspired.",
    link: "https://www.ahmedabadmirror.com/beauty-on-demand-salontym-app-delivers-salon-level-care-at-home/81867105.html#goog_rewarded",
  },
  {
    id: 3,
    title: "INDIAN START UP STORIES",
    image: mediaNewsStartUp.src,
    description:
      "After parting ways with Yes Madam, Vishal Saini, along with Geeta Chetri, started Salontym—a brand redefining at-home salon services. In just 1.5 years, Salontym has earned a 4.8★ rating, gained 50K+ happy customers, and achieved thousands of app downloads. With a strong focus on quality, convenience, and customer satisfaction.",
    link: "https://youtu.be/gLSzLyHu1aw?feature=shared",
  },
  {
    id: 4,
    title: "International Launch in Nepal",
    image: mediaNewsNepal.src,
    description:
      "SalonTym has officially expanded its operations to Nepal, introducing its premium beauty and wellness services in the heart of Kathmandu. With this international launch, SalonTym aims to revolutionize the beauty service industry by offering a seamless booking experience, expert professionals, and top-quality services tailored to customer needs.",
  },
];
